import { render, staticRenderFns } from "./modalUbicacion.vue?vue&type=template&id=dfe26582&scoped=true&"
import script from "./modalUbicacion.vue?vue&type=script&lang=js&"
export * from "./modalUbicacion.vue?vue&type=script&lang=js&"
import style0 from "./modalUbicacion.vue?vue&type=style&index=0&id=dfe26582&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe26582",
  null
  
)

export default component.exports